/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class SearchParam {
    static readonly AssessmentId = 'assessmentId';
}
